// extracted by mini-css-extract-plugin
export default {"lowStockLabel":"Q9-z"};